import { FunctionComponent } from "react";

interface FooterProps {}

const Footer: FunctionComponent<FooterProps> = () => {
  return (
    <div className="footer">
      <p>© 2024 Chirurg dziecięcy lek. Mariusz Sroczyński</p>
    </div>
  );
};

export default Footer;
